import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const BoardViewsButtonMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardViewsButtonMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"waitOn"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WaitOnQuickLoads"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"waitOn"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"BoardViewsButtonMember","document":BoardViewsButtonMemberDocument}} as const;
export type BoardViewsButtonMemberQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
  waitOn: Array<Types.InputMaybe<Types.WaitOnQuickLoads>> | Types.InputMaybe<Types.WaitOnQuickLoads>;
}>;


export type BoardViewsButtonMemberQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);




/**
 * __useBoardViewsButtonMemberQuery__
 *
 * To run a query within a React component, call `useBoardViewsButtonMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardViewsButtonMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardViewsButtonMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      waitOn: // value for 'waitOn'
 *   },
 * });
 */
export function useBoardViewsButtonMemberQuery(baseOptions: Apollo.QueryHookOptions<BoardViewsButtonMemberQuery, BoardViewsButtonMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BoardViewsButtonMemberQuery, BoardViewsButtonMemberQueryVariables>(BoardViewsButtonMemberDocument, options);
      }
export function useBoardViewsButtonMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BoardViewsButtonMemberQuery, BoardViewsButtonMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BoardViewsButtonMemberQuery, BoardViewsButtonMemberQueryVariables>(BoardViewsButtonMemberDocument, options);
        }
export type BoardViewsButtonMemberQueryHookResult = ReturnType<typeof useBoardViewsButtonMemberQuery>;
export type BoardViewsButtonMemberLazyQueryHookResult = ReturnType<typeof useBoardViewsButtonMemberLazyQuery>;
export type BoardViewsButtonMemberQueryResult = Apollo.QueryResult<BoardViewsButtonMemberQuery, BoardViewsButtonMemberQueryVariables>;